// path should look like /business/{id}
// else returns null
export function getBusinessIdFromPath(path) {
    const match = path.match(/\/business\/(?<id>[0-9]+)/);
    if (match && match.groups) {
        return match.groups["id"];
    }
    return null;
}

// Extract market and business name from new URL format: /{market}/{businessName}
// Returns { market: string, businessName: string } or null
export function getBusinessFromNewPath(path) {
    // Guard against undefined or null path
    if (!path || typeof path !== "string") {
        return null;
    }
    // Match /{market}/{businessName} but exclude /business/ routes
    const match = path.match(/^\/(?<market>[^/]+)\/(?<businessName>[^/]+)$/);
    if (match && match.groups && match.groups.market !== "business") {
        return {
            market: match.groups.market,
            businessName: match.groups.businessName,
        };
    }
    return null;
}

export function scrollToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

// Not supporting MSIE at the moment
export function compatibleBrowser() {
    const ua = window.navigator.userAgent;
    return ua.indexOf("MSIE") < 0 && ua.indexOf("Trident") < 0;
}

export function toKebabCase(str) {
    return (
        str &&
        str
            .match(
                /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
            )
            .map((x) => x.toLowerCase())
            .join("-")
    );
}

// Generate business URL in format: /{market}/{businessName}-{id}
// Always includes the business ID at the end for uniqueness
export function getBusinessUrl(
    market,
    businessName,
    allBusinesses,
    businessId = null
) {
    const kebabName = toKebabCase(businessName);

    // Find the business by ID if provided
    let business = null;
    if (businessId) {
        business = allBusinesses.find(
            (b) => b.id == businessId || b.Id == businessId
        );
    }

    // If business found, use its ID
    if (business) {
        const id = business.id || business.Id;
        return `/${market}/${kebabName}-${id}`;
    }

    // Fallback: if no ID provided, try to find by name and use first match's ID
    const matchingBusiness = allBusinesses.find(
        (b) => toKebabCase(b.Name) === kebabName
    );
    if (matchingBusiness) {
        const id = matchingBusiness.id || matchingBusiness.Id;
        return `/${market}/${kebabName}-${id}`;
    }

    // Last resort: return URL without ID (shouldn't happen in normal flow)
    return `/${market}/${kebabName}`;
}

// Extract business name and ID from URL format: {businessName}-{id}
// Returns { name: string, id: string } or null
export function getBusinessNameFromUrl(urlBusinessName) {
    // Match format: name-id (ID is always at the end)
    const match = urlBusinessName.match(/^(.+?)-(\d+)$/);
    if (match) {
        return {
            name: match[1], // Business name without ID
            id: match[2], // Business ID
        };
    }
    // Fallback: if no ID found, return just the name
    return {
        name: urlBusinessName,
        id: null,
    };
}
